import { Create, SimpleForm, TextInput, DateTimeInput, SelectInput, required } from 'react-admin';

const TRANSACTION_TYPES = [
  { id: 'Journal', name: 'Journal' },
  { id: 'Invoice', name: 'Invoice' },
  { id: 'Receipt', name: 'Receipt' },
  { id: 'Refund', name: 'Refund' },
  { id: 'Allocation', name: 'Allocation' },
  { id: 'OpeningBalance', name: 'Opening Balance' },
  { id: 'ClosingBalance', name: 'Closing Balance' },
];

const TRANSACTION_STATUS = [
  { id: 'Pending', name: 'Pending' },
  { id: 'Posted', name: 'Posted' },
  { id: 'Voided', name: 'Voided' },
  { id: 'Reversed', name: 'Reversed' },
];

export const TransactionCreate = () => (
  <Create>
    <SimpleForm
      defaultValues={{
        transactionType: 'Journal',
        transactionDate: new Date().toISOString(),
        status: 'Pending',
      }}
    >
      <TextInput source="transactionNumber" label="Transaction Number" validate={required()} fullWidth />
      <SelectInput source="transactionType" choices={TRANSACTION_TYPES} validate={required()} fullWidth />
      <DateTimeInput source="transactionDate" validate={required()} fullWidth />
      <SelectInput source="status" choices={TRANSACTION_STATUS} validate={required()} fullWidth />
      <TextInput source="description" fullWidth />
      <TextInput source="reference" fullWidth />
      <TextInput source="sourceDocument" label="Source Document" fullWidth />
    </SimpleForm>
  </Create>
);
